import { Component, AfterViewInit, OnInit, ViewChild } from '@angular/core';
import { AbstractAppComponent } from 'projects/game-utils/src/lib/abstract-app.component';
import { WarcabyGameService } from './services/warcaby-game.service';
import { AlertWindowComponent } from 'projects/game-utils/src/lib/windows/alert-window/alert-window.component';
import { WarcabyEventSourceRunnerService } from './services/warcaby-event-source-runner.service';
import { SendLogin } from 'projects/game-utils/src/lib/events/commands/SendLogin';
import { State } from 'projects/game-utils/src/lib/controller/StateFile';
import { LoginCommand } from 'projects/game-utils/src/lib/events/commands/LoginCommand';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent extends AbstractAppComponent implements OnInit, AfterViewInit{

  @ViewChild("reconnectWindow", {static: false}) reconnectWindow:AlertWindowComponent;
  
  title = 'warcaby';


  ngAfterViewInit():void{
    console.log(this.flashvars);
    this.initCommands();
    (<WarcabyGameService>this.gameService).updateSettings(this.flashvars.rules, 
      this.flashvars.playerLocale, 
      this.flashvars.showInRanking, 
      this.flashvars.sendNotification);
    
    (<WarcabyEventSourceRunnerService>this.eventRunner).addWeeklyListener( AppComponent.weeklyRankingStats );
    (<WarcabyEventSourceRunnerService>this.eventRunner).addFriendsWeeklyListener( AppComponent.weeklyFriendsRankingStats );
    (<WarcabyEventSourceRunnerService>this.eventRunner).addTotalListener( AppComponent.totalRankingStats );
    
    this.alertWindows = new Map<string, AlertWindowComponent>();

    this.socketService.ngOnInit(this.flashvars);
  }

  initCommands():void{

    this.applicationController.addResponse("sendLogin", State.SENDING_LOGIN, new SendLogin(this.socketService), null);
    this.applicationController.addResponse("login", State.NOT_LOGGED, new LoginCommand(this.gameService, this.reconnectWindow, this.socketService), null);
    
  }

  ngOnInit() {
    window['hideWaitAchievementAndStartGame'] = { 
      component: this, zone: this.ngZone, 
      hideWaitAchievementAndStartGame: (gameRules:any, diagramType:any) => this.hideWaitAchievementAndStartGame( gameRules, diagramType ), }; 
  }
}
